import httpClient from '@/resources/http-client.js';
import { flyweight } from 'commons/util/interfaces.js';
import { REST } from 'commons/rest/rest.js';
import { refreshUserToken } from '@/resources/auth.js';
import { authorizationRequestInterceptor, createRefreshRetryHandler } from '@/resources/auth-token.js';

/**
 * RestAPIV2 - basic wrapper over XMLHttpRequest for using V2 API
 *
 * @param {string} baseURL The API URL to use
 * @param {string} site Site
 * @constructor
 */
export function RestAPIV2(baseURL, site) {
    // Site 0 (system) is invalid for the v2 api. Use site 1 (global) instead.
    if (site === 0) {
        site = 1;
    }

    REST.call(this, httpClient, `${baseURL}/${site}/`);

    this.api.interceptors.request.use(authorizationRequestInterceptor);
    this.api.interceptors.response.use((response) => response.data.result || response.data,
        createRefreshRetryHandler(this.api, refreshUserToken));
}

RestAPIV2.prototype = Object.create(REST.prototype);

export const restAPIV2 = flyweight(RestAPIV2);
